import { render, staticRenderFns } from "./UpdateAppSubscription.vue?vue&type=template&id=3bca1bd6&scoped=true&"
import script from "./UpdateAppSubscription.vue?vue&type=script&lang=js&"
export * from "./UpdateAppSubscription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bca1bd6",
  null
  
)

export default component.exports